"use client";

import Form3 from "../form3/Form3";
import { FormProps } from "../form3/types";

/**
 * Form 9: Visionaries — unified pool + categories (see variant flags: visionariesHybridForm).
 */
export default function Form9(props: FormProps) {
  return <Form3 {...props} />;
}
